import '../sass/Timeline.scss'

const events = [
    { text: '05/2023-07/2023 : Stage Symfony chez NOOUS', done: true },
    { text: '09/2021-07/2024 : Bachelor informatique chez\nToulouse YNOV Campus', done: true },
    { text: '02/2024-10/2026 : Alternance chez Voltaire Digital', done: true },
    { text: '10/2024-09/2026 : Master développement full stack chez\nToulouse YNOV Campus', done: true },
]

function Timeline() {
    return <div className="timeline" id='timeline'>
        <h2 className="timeline-title">MES EXPÉRIENCES :</h2>
        {events.map((event, i) => (
            <div className="timeline-item" key={i}>
                <div className="timeline-content">
                    <p>{event.text}</p>
                </div>
                <div className="timepoint">
                    <div className={event.done ? 'insidepoint' : 'insidewhitepoint'}></div>
                </div>
            </div>
        ))}
    </div>
}
export default Timeline
